import React, { useState, useEffect, useCallback } from "react";
import GridLayout from "react-grid-layout";
import "/node_modules/react-grid-layout/css/styles.css";
import "/node_modules/react-resizable/css/styles.css";
import { Grid } from "@mui/material";
import {
     Chart as ChartJS,
     ArcElement,
     CategoryScale,
     LinearScale,
     PointElement,
     LineElement,
     Title,
     Tooltip,
     Legend,
} from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { Line } from "react-chartjs-2";
import { Responsive, WidthProvider } from "react-grid-layout";
import UiSlider from "../../../_uiComponents/common/UiSlider";
import DehazeIcon from "@mui/icons-material/Dehaze";
import UiSearchableSelect from "../../../_uiComponents/common/form/UiSearchableSelect";
import UiDbSliderCard from "../../../_uiComponents/common/cards/UiDbSliderCard";
import DownloadIcon from "../../../../styles/images/download-icon.png";
import {
     UiComSectionWr,
     UiComTopSection,
     UiCommunicationRow,
     UiCommunicationInboundRow,
} from "../../../_uiComponents/UiDbComElements";

const ResponsiveGridLayout = WidthProvider(Responsive);
ChartJS.register(
     ArcElement,
     Tooltip,
     Legend,
     CategoryScale,
     LinearScale,
     PointElement,
     LineElement,
     Title,
);

function DashboardWrapper() {
     const activityData = {
          labels: [
               "2024/1/1",
               "2024/1/2",
               "2024/1/3",
               "2024/1/4",
               "2024/1/5",
               "2024/1/2",
               "2024/1/4",
               "2024/1/5",
               "2024/1/2",
          ],
          datasets: [
               {
                    label: "Winning Wednesdays",
                    data: [33, 53, 85, 41, 44, 65, 53, 85, 41],
                    fill: false,
                    borderColor: "#000000",
               },
               {
                    label: "BIG Win",
                    data: [23, 25, 35, 51, 54, 76, 25, 35, 51],
                    fill: false,
                    borderColor: "#FD7D56",
               },
               {
                    label: "High Flyers",
                    data: [55, 75, 78, 81, 95, 76, 55, 75, 78],
                    fill: false,
                    borderColor: "#F2E205",
               },
               {
                    label: "Play your parts",
                    data: [45, 85, 98, 81, 105, 56, 55, 75, 78],
                    fill: false,
                    borderColor: "#0425F5",
               },
               {
                    label: "Rome or Away",
                    data: [65, 75, 88, 91, 108, 59, 98, 75, 66],
                    fill: false,
                    borderColor: "#A46D4D",
               },
          ],
     };

     const rewardData = {
          labels: [
               "2024/1/1",
               "2024/1/2",
               "2024/1/3",
               "2024/1/4",
               "2024/1/5",
               "2024/1/6",
               "2024/1/7",
          ],
          datasets: [
               {
                    label: "Actual",
                    data: [33, 53, 85, 41, 44, 65],
                    fill: false,
                    borderColor: "#000000",
               },
               {
                    label: "Forecast Target",
                    data: [33, 25, 35, 51, 54, 76],
                    fill: false,
                    borderColor: "#FD7D56",
               },
          ],
     };

     const data = {
          labels: ["Sales Consultants", "Sales Manager", "Aftersales Manager"],
          datasets: [
               {
                    label: "",
                    data: [12, 19, 3],
                    backgroundColor: [
                         "rgba(255, 99, 132, 0.2)",
                         "rgba(54, 162, 235, 0.2)",
                         "rgba(255, 206, 86, 0.2)",
                    ],
                    borderColor: [
                         "rgba(255, 99, 132, 1)",
                         "rgba(54, 162, 235, 1)",
                         "rgba(255, 206, 86, 1)",
                    ],
                    borderWidth: 1,
               },
          ],
     };

     const [layouts, setLayouts] = useState([
          { x: 0, y: 0, w: 1, h: 2.5 },
          { x: 1, y: 0, w: 1, h: 2.5 },
          { x: 0, y: 2, w: 2, h: 2.5 },
          { x: 0, y: 3, w: 2, h: 1.5 },
          { x: 0, y: 4, w: 2, h: 2 },
     ]);

     // console.log(layouts);
     const [newLayouts, setNewLayouts] = useState([]);

     const onLayoutChange = (layout) => {
          setLayouts(layout);
          setNewLayouts(layout.map(({ x, y, i }) => ({ x, y, i })));
          // console.log(newLayouts)
     };

     useEffect(() => {
          const updatedLayout = layouts.map((item1) => {
               const item2 = newLayouts.find((item) => item.i === item1.i);
               return { ...item1, ...item2 };
          });
          setLayouts(updatedLayout);
     }, [newLayouts]);

     return (
          <>
               <ResponsiveGridLayout
                    className="layout"
                    draggableCancel=".cancelSelectorName"
                    isResizable={false}
                    compactType="vertical"
                    maxRows={4}
                    draggableHandle=".sba-drag-handle"
                    onLayoutChange={(layout) => onLayoutChange(layout)}
                    breakpoints={{
                         lg: 1300,
                         md: 996,
                         sm: 768,
                         xs: 480,
                         xxs: 0,
                    }}
                    cols={{ lg: 2, md: 2, sm: 2, xs: 1, xxs: 1 }}
               >
                    <div
                         key="1"
                         className="sba-grid-column"
                         data-grid={layouts[0]}
                    >
                         <div className="sba-chart-top-section">
                              <h5>Active users by job role</h5>
                              <UiSearchableSelect />
                              <span className="sba-admin-download-icon">
                                   <img src={DownloadIcon} />
                              </span>
                              <div className="sba-drag-handle">
                                   <DehazeIcon />
                              </div>
                         </div>

                         <Doughnut
                              options={{
                                   responsive: true,
                                   maintainAspectRatio: false,
                                   plugins: {
                                        legend: {
                                             position: "right",
                                        },
                                   },

                                   layout: {
                                        padding: {
                                             bottom: 5,
                                        },
                                   },
                              }}
                              data={data}
                         />
                    </div>
                    <div
                         key="2"
                         className="sba-grid-column"
                         data-grid={layouts[1]}
                    >
                         <div className="sba-chart-top-section">
                              <h5>Reward spend</h5> <UiSearchableSelect />
                              <span className="sba-admin-download-icon">
                                   <img src={DownloadIcon} />
                              </span>
                              <div className="sba-drag-handle">
                                   <DehazeIcon />
                              </div>
                         </div>
                         <Line
                              data={rewardData}
                              options={{
                                   scales: {
                                        x: {
                                             grid: {
                                                  display: false,
                                             },
                                        },
                                        y: {
                                             grid: {
                                                  display: false,
                                             },
                                        },
                                   },
                              }}
                         />
                    </div>

                    <div
                         key="3"
                         className="sba-grid-column"
                         data-grid={layouts[2]}
                    >
                         <div className="sba-chart-top-section">
                              <h5>Day by day activity</h5>{" "}
                              <UiSearchableSelect />
                              <span className="sba-admin-download-icon">
                                   <img src={DownloadIcon} />
                              </span>
                              <div className="sba-drag-handle">
                                   <DehazeIcon />
                              </div>
                         </div>
                         <Line
                              data={activityData}
                              options={{
                                   responsive: true,
                                   maintainAspectRatio: false,
                                   plugins: {
                                        legend: {
                                             position: "right",
                                        },
                                   },
                                   scales: {
                                        x: {
                                             grid: {
                                                  display: false,
                                             },
                                        },
                                        y: {
                                             grid: {
                                                  display: false,
                                             },
                                        },
                                   },
                              }}
                         />
                    </div>

                    <div
                         key="4"
                         className="sba-grid-column "
                         data-grid={layouts[3]}
                    >
                         <div className="sba-drag-handle">
                              <DehazeIcon />
                         </div>
                         <div>
                              <UiSlider>
                                   <div>
                                        <UiDbSliderCard
                                             title="Total Users"
                                             amount="7436"
                                        />
                                   </div>
                                   <div>
                                        <UiDbSliderCard
                                             title="Total Locations"
                                             amount="253"
                                        />
                                   </div>
                                   <div>
                                        <UiDbSliderCard
                                             title="Quizzes Completed"
                                             amount="2344"
                                        />
                                   </div>
                                   <div>
                                        <UiDbSliderCard
                                             title="Custom Rewards Issued"
                                             amount="135"
                                        />
                                   </div>
                                   <div>
                                        <UiDbSliderCard
                                             title="Campaigns"
                                             scheduled="3"
                                             active="5"
                                             closed="32"
                                        />
                                   </div>
                              </UiSlider>
                         </div>
                    </div>

                    <div
                         key="5"
                         className="sba-grid-column "
                         data-grid={layouts[4]}
                    >
                         <div className="sba-chart-top-section">
                              <h5>Communications</h5> <UiSearchableSelect />
                              <div className="sba-drag-handle">
                                   <DehazeIcon />
                              </div>
                         </div>
                         <Grid container>
                              <Grid item xs="4" md="4" lg="6">
                                   <UiComSectionWr>
                                        <UiComTopSection
                                             title="Outbound"
                                             amount="15"
                                        />
                                        <UiCommunicationRow
                                             date="10/01/23"
                                             heading="Winning wednesday"
                                        />
                                        <UiCommunicationRow
                                             date="10/01/23"
                                             heading="Winning wednesday"
                                        />
                                        <UiCommunicationRow
                                             date="10/01/23"
                                             heading="Winning wednesday"
                                        />
                                        <UiCommunicationRow
                                             date="10/01/23"
                                             heading="Winning wednesday"
                                        />
                                   </UiComSectionWr>
                              </Grid>
                              <Grid item xs="4" md="4" lg="6" sx={{ pl: 3 }}>
                                   <UiComSectionWr>
                                        <UiComTopSection
                                             title="Inbound"
                                             amount="15"
                                        />
                                        <UiCommunicationInboundRow
                                             name="Mike Paraott"
                                             state="pending"
                                        />
                                        <UiCommunicationInboundRow
                                             name="Mike Paraott"
                                             state="pending"
                                        />
                                        <UiCommunicationInboundRow
                                             name="Mike Paraott"
                                             state="complete"
                                        />
                                   </UiComSectionWr>
                              </Grid>
                         </Grid>
                    </div>
               </ResponsiveGridLayout>
          </>
     );
}

export default DashboardWrapper;
